module.exports = "dist/logo_tx.png?5f0e985f94d321b1406ac16b16958347";